import { Box } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import styled from 'styled-components';
import { adjustContentVisibility, Section, SectionParagraph, SectionTitle as Title } from '../Content';
import type { DefaultSectionProps } from '../DefaultSectionProps';
import type { AppSketchProps } from './components';
import { AppSketch } from './components';

const Subtitle = styled(SectionParagraph)`
  white-space: normal;

  ${MEDIA_QUERIES.desktop`
    white-space: pre;
  `}
`;
const StyledSection = styled(Section).attrs({
  pb: ['0px'],
})`
  ${adjustContentVisibility}
`;

export interface InstantEverythingProps extends DefaultSectionProps, Pick<AppSketchProps, 'adjustments'> {
  readonly title: string;
  readonly subtitle: string;
  readonly showTopBorder?: boolean;
  readonly appSketchImage?: string;
  readonly appSketchContentLeft: string;
  readonly appSketchContentRight: string;
}

export const InstantEverything: React.FC<InstantEverythingProps> = ({
  title,
  subtitle,
  appSketchImage,
  appSketchContentLeft,
  appSketchContentRight,
  adjustments,
  ...sectionProps
}) => {
  return (
    <StyledSection overflow="hidden" {...sectionProps} pt={[40, 70]}>
      <Title tabIndex={0}>{parse(title)}</Title>
      <Box maxWidth={'990px'} mt={'10px'} px={['30px']}>
        <Subtitle data-edit-for="subtitle" tabIndex={0}>
          {parse(subtitle)}
        </Subtitle>
      </Box>

      <AppSketch
        adjustments={adjustments}
        appSketchImage={appSketchImage}
        contentLeft={appSketchContentLeft}
        contentRight={appSketchContentRight}
      />
    </StyledSection>
  );
};
